import { useState } from "react";
import { ILearningListProps } from "../types/interfaces/ILearningListProps";
import { ILearningItem } from "../types/interfaces/ILearningItem";
import { Box, Button, Card, CardActions, CardContent, Container, Grid, Pagination, Typography } from "@mui/material";
import { modifyLink } from "../../global/utilities/UrlToLearning";

export const LearningList: React.FC<ILearningListProps> = ({items}) => {
    if (items === null || (items.length === 1 && items[0] === null)) return null;
    
    const [page, setPage] = useState(1);
    const itemsPerPage = 3;
    const count = Math.ceil(items.length/itemsPerPage);

    //Function to handle the page change.
    const pageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    return (
        <Container>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold', mt:1 }}>Learning Websites</Box>
            </Typography>
            <Grid container spacing={1} sx={{mt:1}}>
                {items.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item: ILearningItem[] | any ) => (
                    <Grid item xs={12} sm={6} md={4} key={item.LearningItemKey} style={{ display: 'flex', flexDirection: 'column' }}>
                        <Card sx={{ border: 1, borderColor: 'divider' }}>
                            <CardContent sx={{ paddingBottom: 0 }}>
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Title:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{item.Title}</Typography>
                                </Box>
                                {item.Description &&
                                <Box display="flex" alignItems="center">
                                    <Typography variant="body2" fontWeight="bold" color="black" mr={1}>Description:</Typography>
                                    <Typography variant="body2" component="div" sx={{wordBreak: 'break-word'}}>{item.Description}</Typography>
                                </Box>
                                }
                            </CardContent>
                            <CardActions>
                                <Button 
                                    variant="contained"
                                    size="medium"
                                    color="primary" 
                                    sx={{ ml:1, maxWidth: 100, fontSize:18}}
                                    href={modifyLink(item.Link)}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    View
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Pagination count={count} page={page} onChange={pageChange} variant="outlined" shape="rounded" showFirstButton showLastButton sx={{mt:1, mb:5}} />
        </Container>
    );
};